const initialState = {
  throttlingPolicies: [],
  saveThrottlingPolicyRes: {},
  saveThrottlingPolicyErr: null,
  isThrottlePolicyUnique: true,
  isValidCondGrpName: true,
  conditionGroup: {},
  conditionGroupError: {},
  throttleConditionGroups: {},
  throttlePoliyUserApiList: [],
  throttlePoliyIdApiList: [],
  saveThrottlingPolicyApiRes: {},
  saveThrottlingPolicyApiErr: null,
  productThrottlePolicy: {},
  swapThrottlePolicyRes: {},
  swapThrottlePolicyErr: null,
  isTrottlePolicyConsumed: false,
  deletePolicyError: {},
  deleteConditionGrpError: {}
};

const ApiThrottlingReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'THROTTLING_POLICIES':
      return { ...state, throttlingPolicies: action.payload };
    case 'SAVE_THROTTLING_POLICY':
      return {
        ...state,
        saveThrottlingPolicyRes: action.payload,
        saveThrottlingPolicyErr: null
      };
    case 'SAVE_THROTTLING_POLICY_ERR':
      return {
        ...state,
        saveThrottlingPolicyRes: {},
        saveThrottlingPolicyErr: action.error
      };
    case 'THROTTLE_POLICY_UNIQUE':
      return { ...state, isThrottlePolicyUnique: action.value };
    case 'CONDITION_GROUP_NAME_UNIQUE':
      return { ...state, isValidCondGrpName: action.value };
    case 'CREATE_THROTTLE_CONDITION_GROUP':
      return {
        ...state,
        conditionGroup: action.payload,
        conditionGroupError: {}
      };
    case 'THROTTLE_CONDITION_GROUP_ERROR':
      return { ...state, conditionGroupError: action.error };
    case 'THROTTLE_POLICY_DETAILS':
      return { ...state, throttlePolicyDetails: action.payload };
    case 'THROTTLLE_POLICY_CONSUMPTION':
      return { ...state, isTrottlePolicyConsumed: action.value };
    case 'THROTTLE_POLICY_USER_API_LIST':
      return { ...state, throttlePoliyUserApiList: action.payload };
    case 'THROTTLE_POLICY_ID_API_LIST':
      return { ...state, throttlePoliyIdApiList: action.payload };
    case 'SAVE_THROTTLING_POLICY_API':
      return {
        ...state,
        saveThrottlingPolicyApiRes: action.payload,
        saveThrottlingPolicyApiErr: null
      };
    case 'SAVE_THROTTLING_POLICY_API_ERR':
      return {
        ...state,
        saveThrottlingPolicyApiRes: {},
        saveThrottlingPolicyApiErr: action.error
      };
    case 'DELETE_API_THROTTLING_POLICY':
      return {
        ...state,
        deleteThrottlingPolicyApiRes: action.payload
      };
    case 'DELETE_THROTTLE_POLICY_ERROR':
      return { ...state, deletePolicyError: action.error };
    case 'DELETE_THROTTLE_CONDITION_GROUP_ERROR':
      return { ...state, deleteConditionGrpError: action.error };
    case 'PRODUCT_THROTTLE_POLICY_ID':
      return { ...state, productThrottlePolicy: action.payload };
    case 'SWAP_THROTTLING_POLICY_API':
      return {
        ...state,
        swapThrottlePolicyRes: action.payload,
        swapThrottlePolicyErr: null
      };
    case 'SWAP_THROTTLING_POLICY_API_ERR':
      return {
        ...state,
        swapThrottlePolicyRes: {},
        swapThrottlePolicyErr: action.error
      };
    default:
      return state;
  }
};

export default ApiThrottlingReducer;
